<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__body">
      <!-- Filter -->
      <div class="kt-form kt-form--label-right">
        <div class="row align-items-center">
          <div class="col-xl-12 order-2 order-xl-1 pr-0">
            <form class="row align-items-center" [formGroup]="form">
              <!-- Filter first row -->
              <div class="col-12 row pr-0">
                <!-- Username -->
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Username:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <kt-member-dropdown class="dropdown-maxheight" [form]="form" [dropdownSettings]='dropdownSettings'
                    [formName]="'member_account_id'" [selectionAttributes]="'id'"></kt-member-dropdown>
                </div>
                <!-- Group -->
                <div class="col-md-1 kt-form__label col-form-label">
                  <label class="mb-0">Group</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <select formControlName="member_group_id" class="form-control">
                    <option value="all"> All </option>
                    <option [value]="value.id" *ngFor="let value of dropdown.groups | async">
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <!-- Status -->
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Status:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <select formControlName="status" class="form-control">
                    <option value="all"> All </option>
                    <option [value]="i" *ngFor="let value of dropdown.statuses ; let i = index">
                      {{ value }}
                    </option>
                  </select>
                </div>
                <!-- Reason -->
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>Reason:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <select formControlName="reason" class="form-control">
                    <option value="all"> All </option>
                    <option [value]="value.id" *ngFor="let value of dropdown.reason ; let i = index">
                      {{ value.name }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-3">
        <div class="dropdown dropdown-inline">
          <kt-search-button [loading]="loading" (search)="onSubmit()"></kt-search-button>
          <kt-clear-button (clear)="onClear()"></kt-clear-button>
        </div>
      </div>
      <div class="kt-section">
        <div class="kt-section__content">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-striped table-sortable">
              <thead>
                <tr>
                  <th class="sort-enabled" (click)="onSortColumn('id')" [ngClass]="sortingConfig.id" [class.sort-selected]="sortingSelection.sort_by === 'id'">ID</th>
                  <th class="sort-enabled" (click)="onSortColumn('username')" [ngClass]="sortingConfig.username" [class.sort-selected]="sortingSelection.sort_by === 'username'">Username</th>
                  <th class="sort-enabled" (click)="onSortColumn('current_group')" [ngClass]="sortingConfig.current_group" [class.sort-selected]="sortingSelection.sort_by === 'current_group'">Upgrade From</th>
                  <th class="sort-enabled" (click)="onSortColumn('next_member_group')" [ngClass]="sortingConfig.next_member_group" [class.sort-selected]="sortingSelection.sort_by === 'next_member_group'">Upgrade To</th>
                  <th class="sort-enabled" (click)="onSortColumn('total_deposits')" [ngClass]="sortingConfig.total_deposits" [class.sort-selected]="sortingSelection.sort_by === 'total_deposits'">Total Deposit</th>
                  <th class="sort-enabled" (click)="onSortColumn('reason')" [ngClass]="sortingConfig.reason" [class.sort-selected]="sortingSelection.sort_by === 'reason'">Reason</th>
                  <th class="sort-enabled" (click)="onSortColumn('remarks')" [ngClass]="sortingConfig.remarks" [class.sort-selected]="sortingSelection.sort_by === 'remarks'">Remark</th>
                  <th class="text-center sort-enabled" (click)="onSortColumn('status')" [ngClass]="sortingConfig.status" [class.sort-selected]="sortingSelection.sort_by === 'status'">Status</th>
                  <th class="info-column">Info</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody *ngIf="(members$ | async) as rows">
                <tr *ngFor="let row of rows">
                  <td>{{ row.id }}</td>
                  <td>{{ row.username }}</td>
                  <td>{{ row.current_group }}</td>
                  <td>{{ row.next_member_group }}</td>
                  <td>{{ row.total_deposits }}</td>
                  <td>{{ vipVerificationReason[row.reason] }}</td>
                  <td>{{ row.remarks }}</td>
                  <td class="text-center"><span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide"
                      [ngClass]="'kt-badge--' + row.status"> {{ vipVerificationStatus[row.status] }}</span></td>
                  <!-- <td>{{ row.status_name }}</td> -->
                  <td>
                    <strong>Updated By </strong> : {{ row.updated_by ? row.updated_by : '-' }}<br />
                    <strong>Created At </strong> : {{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm' }} <br />
                    <strong>Updated At </strong> : {{ row.updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }} <br />
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-success mx-2" (click)="onUpdate('approve', row)"
                      [disabled]="row.status !== 0">Approve</button>
                    <button type="button" class="btn btn-danger mx-2" (click)="onUpdate('reject', row)"
                      [disabled]="row.status !== 0">Reject</button>
                  </td>
                </tr>
              </tbody>
              <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
            </table>
          </div>
          <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
            <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize" [directionLinks]="true"
              [boundaryLinks]="true" [rotate]="true" [collectionSize]="pagination.total"
              (pageChange)="onViewPageBy(page)">
            </ngb-pagination>
            <div class="kt-pagination__toolbar">
              <select (change)="onPerPage($event)" [(ngModel)]="pageSize"
                class="form-control kt-font-brand page-size">
                <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
              </select>
              <span class="pagination__desc">
                Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onSubmit()"></kt-swal-alert>
